import React from "react";
import { connect } from "react-redux";
import Selector from "./selector";
import { offAlertaPlanMovilidad } from "../Planes/actions";
import { openCloseToast } from "../../Global/actions";
import BANNER from "../../../images/BANNER_WEB_MOVILIDAD.JPG";

// css
import "../styles/style-plan.css";

class HeaderPlanMovilidad extends React.PureComponent {
  componentDidUpdate = () => {
    // manejo las alertas
    if (this.props.alertaCall) {
      this.props.dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: this.props.alertaMensaje,
        typeStyle: this.props.alertaCode,
        displayTime: 5000
      }));
      this.props.dispatch(offAlertaPlanMovilidad());
    }
  }

  render() {
    return (
      <div>
        <section id="video-carousel-home" className="carousel slide carousel-fade pt-20" data-ride="carousel">
          <div className="container-fluid">
            <div className="PM-carousel-inner-plan" role="listbox">
              <div className="PM-carousel-item active">
                <div className="view">
                  <img src={BANNER} alt="banner plan movilidad" width="100%" height="100%"/>
                  <div className="mask rgba-indigo-light"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section id="empresa-centro" className="row pt-20 col-sm-12" style={{ paddingLeft: 30 }}>
          <Selector />
        </section> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  alertaCode: state.planMovilidad.alertaCode,
  alertaMensaje: state.planMovilidad.alertaMensaje,
  alertaCall: state.planMovilidad.alertaCall,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderPlanMovilidad);
